<template>
    <div>
        <app-header></app-header>
        <div class="container-fluid">
            <div class="row">
                <app-sidebar></app-sidebar>

                <main class="col-sm-9 ml-sm-auto col-md-10 pt-3" role="main">
                    <router-view></router-view>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
import header from '../components/header.vue'
import sidebar from '../components/sidebar.vue'

export default {
    components: {
        appHeader: header,
        appSidebar: sidebar,
    },
}
</script>

<style>
.btn-margin {
    margin-left: 0.5rem;
}

/*
 * Base structure
 */
/* Move down content because we have a fixed navbar that is 3.5rem tall */
body {
    padding-top: 3.5rem;
}

/*
 * Typography
 */
h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}

/*
 * Sidebar
 */
.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}

/* Sidebar navigation */
.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item + .nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}

/*
 * Dashboard
 */
/* Placeholders */
.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

.pt-3 {
    padding-top: 2.1rem !important;
}
</style>
